"use client";
import { createContext } from "react";
export const SetRootElementContext = createContext(() => { });
//# sourceMappingURL=RootElementContext.js.map